var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-flex",
    { staticClass: "d-flex flex-row", staticStyle: { gap: "24px" } },
    [
      _c("v-checkbox", {
        attrs: {
          label: "Cluster",
          "persistent-hint": "",
          "true-value": "DBSCAN",
          "false-value": "None",
        },
        model: {
          value: _vm.dbScan,
          callback: function ($$v) {
            _vm.dbScan = $$v
          },
          expression: "dbScan",
        },
      }),
      _vm._v(" "),
      _c("v-text-field", {
        attrs: {
          label: "Clustering Min Points",
          disabled: _vm.dbScan == "None",
          "persistent-hint": "",
          type: "number",
          min: "0",
        },
        model: {
          value: _vm.dbScanMinPts,
          callback: function ($$v) {
            _vm.dbScanMinPts = $$v
          },
          expression: "dbScanMinPts",
        },
      }),
      _vm._v(" "),
      _c("v-text-field", {
        attrs: {
          label: "Clustering Epsilion",
          disabled: _vm.dbScan == "None",
          "persistent-hint": "",
          type: "number",
          min: "0",
        },
        model: {
          value: _vm.dbScanEpsilion,
          callback: function ($$v) {
            _vm.dbScanEpsilion = $$v
          },
          expression: "dbScanEpsilion",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }